import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  token: string;
  spotAddress: string;
}

const QrDisplay = ({ open, onOpenChange, token, spotAddress }: Props) => {
  const value = `bayzo:spot:${token}`;

  const handlePrint = () => {
    const w = window.open("", "_blank", "width=600,height=700");
    if (!w) return;
    const canvas = document.querySelector<HTMLCanvasElement>("#bayzo-qr-canvas canvas");
    const dataUrl = canvas?.toDataURL("image/png");
    w.document.write(`
      <html><head><title>Bayzo QR — ${spotAddress}</title></head>
      <body style="font-family:sans-serif;text-align:center;padding:40px;">
        <h2>Bayzo Parking</h2>
        <p>${spotAddress}</p>
        <img src="${dataUrl}" style="width:300px;height:300px;" />
        <p style="margin-top:24px;">Scan to check-in / check-out</p>
        <script>window.onload=()=>window.print();</script>
      </body></html>
    `);
    w.document.close();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Spot QR Code</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-4">
          <p className="text-sm text-muted-foreground text-center">Drivers scan this code to check-in or check-out.</p>
          <div id="bayzo-qr-canvas" className="bg-white p-4 rounded-md">
            <QRCodeCanvas value={value} size={220} includeMargin />
          </div>
          <Button onClick={handlePrint} variant="outline" className="w-full">
            <Printer className="h-4 w-4 mr-2" /> Print
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QrDisplay;
